import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT, LocalStorageKeys, LocalStorageService } from '@iot-platform/core';
import { BusinessProfile, CommonApiListResponse, Environment, Organization } from '@iot-platform/models/common';
import momentTimezones from 'moment-timezone';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthBusinessProfilesService {
  private readonly environment: Environment = inject(ENVIRONMENT);
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly storage: LocalStorageService = inject(LocalStorageService);

  public selectBusinessProfile(profile: BusinessProfile) {
    const zone = profile?.timezoneDetails?.name ? momentTimezones().tz(profile.timezoneDetails.name).format('Z') : null;
    const bp: BusinessProfile = {
      ...profile,
      timezoneDetails: { ...profile?.timezoneDetails, offset: zone }
    } as BusinessProfile;
    this.storage.set(LocalStorageKeys.STORAGE_BUSINESS_PROFILE_KEY, JSON.stringify(bp));
    return of(profile);
  }

  public getBusinessProfileId() {
    return this.storage.get(LocalStorageKeys.STORAGE_BUSINESS_PROFILE_KEY)
      ? JSON.parse(this.storage.get(LocalStorageKeys.STORAGE_BUSINESS_PROFILE_KEY)).id
      : '';
  }

  public getEntityById(entityId: string): Observable<Organization> {
    return this.httpClient.get<Organization>(`${this.environment.api.url}${this.environment.api.endpoints.entities}/${entityId}`);
  }

  public getPerimeterEntities(): Observable<Organization[]> {
    return this.httpClient
      .get<CommonApiListResponse<Organization>>(`${this.environment.api.url}${this.environment.api.endpoints.entities}`)
      .pipe(map((response) => response.content));
  }

  private getBusinessProfileFromLocalStorage() {
    return JSON.parse(this.storage.get(LocalStorageKeys.STORAGE_BUSINESS_PROFILE_KEY));
  }
}
